import { CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetContact =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.contact_us.get;
      const response = await PostFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      console.log({ response });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageContactUs =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyFormData = {};
      
      if (editMode) {
        bodyFormData.id = values?.id;
      }
      
      if (CheckDataIfExit(values?.name)) {
        bodyFormData.name = values?.name?.trim();
      }
      
      if (CheckDataIfExit(values?.address)) {
        bodyFormData.address = values?.address?.trim();
      }
      
      if (CheckDataIfExit(values?.email)) {
        bodyFormData.email = values?.email?.trim();
      }
      
      if (CheckDataIfExit(values?.address_link)) {
        bodyFormData.address_link = values?.address_link?.trim();
      }

      // Handle contact numbers array
      if (values?.contact_numbers && Array.isArray(values.contact_numbers)) {
        // Filter out empty contact numbers and validate
        const validContactNumbers = values.contact_numbers
          .filter(num => 
            CheckDataIfExit(num?.type) && 
            CheckDataIfExit(num?.number)
          )
          .map(num => ({
            type: num.type.trim(),
            number: num.number.trim()
          }));
        
        bodyFormData.contact_numbers = validContactNumbers;
      }

      console.log("Sending data:", bodyFormData);

      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode ? UrlApi.contact_us.edit : UrlApi.contact_us.add,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditContactUs =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      
      if (allData) {
        data = allData;
      } else {
        data = {
          id: id,
          [nameFailed]: dataFailed,
        };
        
        // Special handling for contact_numbers field
        if (nameFailed === 'contact_numbers' && Array.isArray(dataFailed)) {
          data.contact_numbers = dataFailed
            .filter(num => 
              CheckDataIfExit(num?.type) && 
              CheckDataIfExit(num?.number)
            )
            .map(num => ({
              type: num.type.trim(),
              number: num.number.trim()
            }));
        }
      }

      console.log("Editing data:", data);

      const response = await PostFunction({
        data,
        Route: UrlApi.contact_us.edit,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteContactUs =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data = {
        idscontactus: id,
      };
      
      const response = await PostFunction({
        data,
        Route: UrlApi.contact_us.delete,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };